// extracted by mini-css-extract-plugin
export default {"host-attendance-record__container":"styles_host-attendance-record__container__07e5m"};